import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyListOption as MatListOption } from '@angular/material/legacy-list';

@Component({
  standalone: false,
  selector: 'sbnb-property-detail-language-selection',
  templateUrl: './property-detail-language-selection.component.html',
  styleUrls: ['./property-detail-language-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyDetailLanguageSelectionComponent implements OnInit {
  @Input() languages: string[];
  @Input() edited: boolean;
  @Input() hasAirbnbListing: boolean = true;
  @Output() updated: EventEmitter<string[]> = new EventEmitter();

  label: string = 'Languages';
  editMode: boolean = false;

  availableLanguages: string[] = ['English', 'French', 'German'];

  constructor() { }

  ngOnInit(): void { }

  setLanguages(selectedOptions: SelectionModel<MatListOption>) {
    this.languages = selectedOptions.selected.map((x) => x.value);

    this.editMode = false;
    this.updated.emit(this.languages);
  }
}
